// import _ from "lodash";
import { onMounted, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
// api
import { getArticleList } from "@/api/common";
// hooks
import usePagination from "@/hooks/common/pagination";
// config
import { newsTabData } from "@/config/race-news";

export function useRaceNews(pageSize = 5) {
  const router = useRouter();
  const route = useRoute();
  onMounted(() => {
    getArticleListApi();
  });
  const newsState = reactive({
    // 项目慕了code码，赛事新闻：match_center_hot_news_list，赛事资讯：match_center_hot_match_info
    code: "match_center_hot_news_list",
    newsType: 1, // 1-赛事新闻
    newsData: [], // 资讯列表数据
    newsTabData: newsTabData,
    pageCfg: { forceEllipses: true },
    nextTxt: "",
    pageCount: 1,
    pageSize: 5,
    total: 0,
  });

  const { paginationState, paginationChange } = usePagination({
    currentPage: 1,
    pageSize: pageSize,
    total: 0,
    onChange: () => {
      getArticleListApi();
    },
  });

  /**
   * 接口
   */
  // 获取文章列表
  function getArticleListApi() {
    const params = {
      code: [newsState.code],
      page: paginationState.currentPage,
      pageRows: pageSize,
    };
    getArticleList(params)
      .then((res) => {
        const data = res.data;
        newsState.newsData = data.list || [];
        paginationState.total = data.total;
        newsState.total = data.total;

        newsState.pageCount = Math.ceil(data.total / pageSize);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // 资讯类型切换
  function switchNewsFct({ value }) {
    paginationState.currentPage = 1;
    newsState.newsType = value;
    newsState.code =
      newsState.newsType === 1
        ? "match_center_hot_news_list"
        : "match_center_hot_match_info";
    getArticleListApi();
  }

  // 点击资讯item
  function clickNewsItemFct(item) {
    const isHome = route.path === "/" ? 1 : 2;
    router.push({
      path: "/news-detail",
      query: {
        article_id: item.article_id,
        news_type: newsState.newsType,
        is_home: isHome,
      },
    });
  }

  // 点击go按钮分页
  function clickGoBtnFct(e) {
    e.stopPropagation();
    if (!newsState.nextTxt) {
      return;
    }

    // 获取总页码数
    const pageCount = Math.ceil(paginationState.total / pageSize);

    // 当跳转的页码 > 总页码时
    if (parseInt(newsState.nextTxt) > pageCount) {
      newsState.nextTxt = pageCount;
      paginationState.currentPage = pageCount;
    }

    if (parseInt(newsState.nextTxt) === paginationState.currentPage) {
      return;
    }

    paginationState.currentPage = parseInt(newsState.nextTxt);
  }

  // 点击下一页分页
  function clickNextPageFct(e) {
    e.stopPropagation();
    newsState.nextTxt = "";

    // 获取总页码数
    const pageCount = Math.ceil(paginationState.total / pageSize);

    // 跳转到最后一页时，则禁止再次触发
    if (paginationState.currentPage >= pageCount) {
      return;
    }
    paginationState.currentPage = paginationState.currentPage + 1;
  }

  return {
    newsState,
    paginationState,
    paginationChange,
    switchNewsFct,
    clickNewsItemFct,
    clickGoBtnFct,
    clickNextPageFct,
  };
}
